import type { Message } from "@mux/sdk/v2"
import { messageTurnDiff, type TurnDiffMessage } from "@/transport/turn-diffs"

// Diff revisions are independent of message metadata revisions.
export function mergeMessageTurnDiff(incoming: Message, current?: Message): Message {
  const previous = messageTurnDiff(current)
  const next = messageTurnDiff(incoming)
  if (incoming.role === "user" && previous && (!next || previous.revision > next.revision)) {
    return { ...incoming, turnDiff: previous } as TurnDiffMessage
  }
  return incoming
}
